import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';

import { ParticipantesSolicitudDTO } from 'src/app/core/models/vinculacion/vinculacion-Interfaces';

import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlVinculacion;

@Injectable()
export class ParticipantesSolicitudService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) { }

  getParticipantesSolicitudService(): Observable<BodyListResponse<ParticipantesSolicitudDTO>> {
    return this.http.get<BodyListResponse<ParticipantesSolicitudDTO>>(API_URL + '/api/v1/participantesSolicitud/todos');
  }

  getParticipantesSolicitudPorSolicitudService(codigo: string): Observable<BodyListResponse<ParticipantesSolicitudDTO>> {
    return this.http.get<BodyListResponse<ParticipantesSolicitudDTO>>(API_URL + '/api/v1/participantesSolicitud/solicitud/' + codigo);
  }

  getParticipantesSolicitudPorCarreraService(carrera: string): Observable<BodyListResponse<ParticipantesSolicitudDTO>> {
    return this.http.get<BodyListResponse<ParticipantesSolicitudDTO>>(API_URL + '/api/v1/participantesSolicitud/carrera/' + carrera);
  }

  getParticipantesSolicitudPorNumeroIdentificacionFlujoTrabajoService(numeroIdentificacion: string): Observable<BodyListResponse<ParticipantesSolicitudDTO>> {
    return this.http.get<BodyListResponse<ParticipantesSolicitudDTO>>(API_URL + '/api/v1/participantesSolicitud/identificacionFlujo/' + numeroIdentificacion);
  }
  //@GetMapping({ "/carrera/{carrera}/proceso{proceso}/{numeroIdentificacion}" })

  getParticipantesSolicitudPorNumeroIdentificacionCarreraFlujoTrabajoService(proceso: string, numeroIdentificacion: string): Observable<BodyListResponse<ParticipantesSolicitudDTO>> {
    return this.http.get<BodyListResponse<ParticipantesSolicitudDTO>>(API_URL + '/api/v1/participantesSolicitud/proceso/' + proceso + '/' + numeroIdentificacion);
  }


  guardarParticipantesSolicitudService(participantesSolicitudDTO: ParticipantesSolicitudDTO): Observable<BodyResponse<ParticipantesSolicitudDTO>> {
    return this.http.post<any>(API_URL + '/api/v1/participantesSolicitud', participantesSolicitudDTO);
  }

  getParticipantesSolicitudPorCodigoParticipanteSolicitudService(codigoParticipanteSolicitud: string): Observable<BodyResponse<ParticipantesSolicitudDTO>> {
    return this.http.get<BodyResponse<ParticipantesSolicitudDTO>>(API_URL + '/api/v1/participantesSolicitud/' + codigoParticipanteSolicitud);
  }

  getParticipantesSolicitudPorTutorService(codigoTutor: string): Observable<BodyListResponse<ParticipantesSolicitudDTO>> {
    return this.http.get<BodyListResponse<ParticipantesSolicitudDTO>>(API_URL + '/api/v1/participantesSolicitud/tutor/' + codigoTutor);
  }
}
